import React from 'react';

import {
  FeatureCategories,
  WindowFilterItemTypes,
} from 'src/modules/designStudio/constants';
import {
  DesignConfig,
  WindowParametricProperties,
} from 'src/modules/designStudio/types';

import { UpdateDesignFunction } from '../../../../providers/HistoryProvider';
import { IconList } from '../../IconList';

export const WindowFilter = ({
  updateDesign,
  designConfig,
  title,
  windowDesignConfigProperty,
  items,
}: {
  updateDesign: UpdateDesignFunction;
  designConfig: DesignConfig;
  title: string;
  windowDesignConfigProperty: WindowParametricProperties;
  items: WindowFilterItemTypes[];
}) => {
  const onPress = (id: string) => {
    const gridSelectedId =
      designConfig.WINDOWS[WindowParametricProperties.GRID_TYPE];
    const frameSelectedId =
      designConfig.WINDOWS[WindowParametricProperties.FRAME_TYPE];
    // There are default selections in machete and they aren't what we want so we have to over ride them
    // https://hoverinc.atlassian.net/browse/DS-290
    if (
      !gridSelectedId &&
      !frameSelectedId &&
      windowDesignConfigProperty === WindowParametricProperties.FRAME_TYPE
    ) {
      const defaultUpdate = {
        ...designConfig.WINDOWS,
        frameType: id,
        gridType: 'none',
      };
      updateDesign({
        category: FeatureCategories.WINDOW,
        update: {
          ...defaultUpdate,
        },
        trackingData: {
          parameter: title,
          product: FeatureCategories.WINDOW,
          selection: id,
        },
      });
    }

    updateDesign({
      category: FeatureCategories.WINDOW,
      update: { ...designConfig.WINDOWS, [windowDesignConfigProperty]: id },
      trackingData: {
        parameter: title,
        product: FeatureCategories.WINDOW,
        selection: id,
      },
    });
  };

  const selectedId = designConfig.WINDOWS[windowDesignConfigProperty];

  return (
    <IconList
      items={items}
      onPress={onPress}
      selectedId={selectedId}
      title={title}
    />
  );
};
